import { DatePickerField } from './DatePickerField';
import { todayISO, addDaysISO } from '@/lib/format';

interface VisitDatePickerProps {
  value: string;
  onChange: (dateISO: string) => void;
  /** Window length in days (today..+maxDays). */
  maxDays?: number;
}

/** Today..+maxDays visit-date chooser (Asia/Jakarta), shown as dd-mm-yyyy. */
export function VisitDatePicker({ value, onChange, maxDays = 7 }: VisitDatePickerProps) {
  return (
    <DatePickerField
      value={value}
      onChange={onChange}
      min={todayISO()}
      max={addDaysISO(maxDays)}
      prefix="Kunjungan:"
      placeholder="Pilih tanggal"
    />
  );
}
